export enum AccountGroup {
  CurrentAssetsDebtors = 6,
  CurrentLiabilities = 10,
  Income = 1,
}

export enum AccountType {
  DonationsAndLegacies = 1,
}
